<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Declaratie type {{type?.id ? 'aanpassen' : 'aanmaken'}}</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.declarationTypes}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    @if (form()) {
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <form [formGroup]="form()">
                    <mat-form-field class="w-100">
                        <input [formControl]="fc.name" matInput placeholder="Naam" type="text">
                        <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                    </mat-form-field>
                    <mat-form-field class="w-100">
                        <input matInput
                               type="text"
                               appDecimalInput
                               decimalInput="2"
                               [formControl]="fc.unit_price"
                               placeholder="Prijs">
                        <mat-hint>
                            Laat dit veld leeg als er bij dit declaratie type een vrij bedrag ingevuld mag worden.
                        </mat-hint>
                    </mat-form-field>
                    <div class="pt-3 pb-2">
                        <mat-checkbox [formControl]="fc.distance" color="primary">
                            Ritregistratie
                        </mat-checkbox>
                    </div>
                </form>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6 col-12">
                <div class="d-flex">
                    <button mat-button routerLink="/{{Routenames.declarationTypes}}">Terug</button>
                    <div class="spacer"></div>
                    <button (click)="save()" [disabled]="form().invalid" color="primary" id="btn-save" mat-raised-button>
                        Opslaan
                    </button>
                </div>
            </div>
        </div>
    }
</div>
